export const demandCaptureTokens = {
  color: {
    text: {
      primary: "#12171f",
      body: "#101828",
      bodyAlt: "#17171c",
      strong: "#0a0a0a",
      secondary: "#6b7585",
      meta: "#69707d",
      label: "#6a7282",
      disabled: "rgba(0, 0, 0, 0.38)",
      danger: "#991a1a",
      dangerStrong: "#5F2120",
      onAccent: "#fe6600",
    },
    surface: {
      base: "#ffffff",
      subtle: "#fafafc",
      canvas: "#fbfcfd",
      danger: "#fceded",
    },
    border: {
      subtle: "#ebf0f5",
      default: "#e2e3e1",
      form: "#e4e7f1",
      photo: "#ddd",
      canvas: "rgba(17, 43, 134, 0.1)",
    },
    accent: {
      primary: "#fe6600",
      successIcon: "#52c41a",
      warningIcon: "#fa8c16",
      errorIcon: "#ff4d4f",
      alertIcon: "#D32F2F",
    },
    alert: {
      info: {
        background: "#e5f6fd",
        text: "#014361",
        icon: "#0288d1",
      },
    },
    ink: {
      pen: "#000000",
    },
  },
  radius: {
    sm: 3,
    md: 6,
    lg: 8,
  },
  font: {
    family: "Inter, sans-serif",
    size: {
      xs: 10,
      sm: 12,
      md: 14,
      lg: 16,
      xl: 18,
      iconLg: 64,
    },
    weight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    letterSpacing: {
      label: 0.4,
      alertTitle: 0.15,
      alertBody: 0.17,
    },
    lineHeight: {
      normal: "normal" as const,
      paragraph: 1.4,
    },
  },
  spacing: {
    xxs: 4,
    xs: 8,
    sm: 11,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 48,
    section: 64,
    card: 31,
    cardPadX: 18,
    cardPadY: 14,
  },
} as const;

export type DemandCaptureTokens = typeof demandCaptureTokens;
